module.exports = __webpack_public_path__ + "media/images/Intercom-5052e7c9.png";